
import Vue from 'vue'
import VueRouter from 'vue-router'
// import Vant from 'vant'
import { Dialog, Popup, Image, Overlay ,Swipe, SwipeItem } from 'vant'
import Index from './Index.vue'
import store from './store/init'
import 'vant/lib/index.css'
import './css/commom.scss'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import utils from './store/utils'
var sensors = require('sa-sdk-javascript');
Vue.use(Image).use(Popup).use(Dialog).use(Overlay).use(VueAwesomeSwiper).use(Swipe).use(SwipeItem);
let uid = utils.getUrlKey('uid')
let apptype = utils.getUrlKey('apptype')
// console.log(`${apptype}_${uid}`)
//import Loading from './components/element/Loading.vue';
//import { lazyComponent } from './plugin/tools';
// import VueLazyload from 'vue-lazyload'

// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   attempt: 3
// });
Vue.use(VueRouter);
Vue.prototype.sensors = sensors;
sensors.init({
  server_url: 'https://shence.jiushengliye.com/sa?project=QZA01',
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'not_collect',
    show_log: true,
    //是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'not_collect',
  }
});
const
  router = new VueRouter({
    routes: [
      { path: "/", component: () => import('./components/Home.vue') },
      { path: "/record", component: () => import('./components/Record.vue') },
      //{ path: "/selfInfo/:statusTab", name:"selfInfo" , component: () => import('./components/SelfInfo.vue') },
      { path: "/selfInfo", name:"selfInfo" , component: () => import('./components/SelfInfo.vue') },
      { path: "/address", name:"address" ,component: () => import('./components/AddLocation.vue') },
      { path: "/bank", component: () => import('./components/AddBank.vue') },
      { path: "/addCheck", component: () => import('./components/CheckInfo.vue') },
      { path: "/bankCheck", component: () => import('./components/CheckBank.vue') },
      { path: "/editbank", component: () => import('./components/EditBank.vue') },
      { path: "/editaddress", component: () => import('./components/EditLocation.vue') },
      { path: "/editalipay", component: () => import('./components/EditAlipay.vue') },
      { path: "/prodetails", name:"prodetails" , component: () => import('./components/Prodetails.vue') },
      { path: "/determineorder", name:"determineorder" ,component: () => import('./components/DetermineOrder.vue') },

    ]
  });
  sensors.login(`${apptype}_${uid}`)
  router.afterEach(() => {
    Vue.nextTick(() => {
      sensors.quick("autoTrackSinglePage",{
        app_number: apptype
      });
    })
  });
new Vue({
  router,
  store,
  render: h => h(Index),
}).$mount('#app')
